<template>
	<div v-loading="loading" class="base_scroll_page" style="padding: 15px 15px 15px 200px;">
		<!-- 区域选择 -->
		<AreaChoise @nodeClick="handleAreaChoiseSelect"></AreaChoise>
		<!-- 区域选择 end -->
		
		<!-- 主体区域 -->
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">医院名：</span>
					<el-input v-model="hospital_name" class="b_inp" placeholder="医院名称"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">创建人：</span>
					<el-input v-model="hospital_creater" class="b_inp" placeholder="创建人"></el-input>
				</div>

				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="hospital_startTime"
						:editable="false"
						placeholder="开始时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchStartTimeClick"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="hospital_endTime"
						:editable="false"
						placeholder="结束时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchEndTimeClick"
					>
					</el-date-picker>
				</div>
				
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- action -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="exportExcel">导出数据</el-button>
				<el-button type="primary" @click="handleAddHospitalClick">新增医院</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
					@selection-change="handleTableSelectionChange"
				>
					<el-table-column
						type="selection"
					>
					</el-table-column>
					<el-table-column
						prop="name"
						label="企业名称"
					>
					</el-table-column>
					<el-table-column
						prop="code"
						label="编码"
					>
					</el-table-column>
					<el-table-column
						prop="creater"
						label="创建人"
					>
					</el-table-column>
					<el-table-column
						prop="creatDate"
						label="创建时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="400"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleViewHospitalClick(scope.row)"
							>查看</el-button>
							<el-button
								@click="handleUpdateHospitalClick(scope.row)"
							>修改</el-button>
							<el-button
								@click="handleManageHospitalClick(scope.row)"
							>管理员</el-button>
							<el-button
								@click="handleRechargeHospitalClick(scope.row)"
							>充值</el-button>
							<el-button
								@click="handleHospitalConsumeCountClick(scope.row)"
							>消费统计</el-button>
							<el-button
								@click="handleHospitalRechargeRecordClick(scope.row)"
							>充值记录</el-button>
							<el-button
								@click="handleHospitalConsumeRecordClick(scope.row)"
							>消费记录</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div style="float: left;">
					<el-button type="danger" @click="handleBatchDeleteClick">批量删除</el-button>
				</div>
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页"
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		<!-- 主体区域 end -->
		
		<!-- 新增医院弹出框 -->
		<Popup 
			v-model="addHospital_popup_display"
			title="新增医院"
			@confirmClick="handleAddHospitalPopupConfirmClick"
		>
			<div v-loading="add_loading" style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>名称</span>
					<el-input v-model="addHospital_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addHospitalName_tip"><i class="b_icon"></i>请输入医院名称</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>资质等级</span>
					<el-select v-model="addHospital_level" placeholder="请选择" style="width: 100%;">
						<el-option value="1" label="一级甲等"></el-option>
						<el-option value="2" label="一级乙等"></el-option>
						<el-option value="3" label="一级丙等"></el-option>
						<el-option value="6" label="二级甲等"></el-option>
						<el-option value="7" label="二级乙等"></el-option>
						<el-option value="8" label="二级丙等"></el-option>
						<el-option value="9" label="三级特等"></el-option>
						<el-option value="10" label="三级甲等"></el-option>
						<el-option value="11" label="三级乙等"></el-option>
						<el-option value="12" label="三级丙等"></el-option>
					</el-select>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>所属区域</span>
					<VDistpicker @province="handleAddHospitalAddrProvinceSelect" @city="handleAddHospitalAddrCitySelect" @area="handleAddHospitalAddrAreaSelect"></VDistpicker>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addHospitalAddr_tip"><i class="b_icon"></i>请选择区域</template></div>
				<div class="base_form_row">
					<span class="b_label">简介</span>
					<el-input
						v-model="addHospital_desc"
						type="textarea"
						:rows="4"
						placeholder="医院简介"
					>
					</el-input>
				</div>
				<div style="margin-top: 20px;padding: 15px;border: 1px dashed #ccc;border-radius: 10px;">
					<h1 style="font-size: 16px;color: #5f6468;text-align: center;line-height: 36px">默认医院管理者</h1>
					<div class="base_form_row" style="margin-top: 20px;">
						<span class="b_label"><span style="color: #f00;">*</span>姓名</span>
						<el-input v-model="addHospitaler_name" placeholder="姓名"></el-input>
					</div>
					<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addHospitalerName_tip"><i class="b_icon"></i>请输入姓名</template></div>
					<div class="base_form_row">
						<span class="b_label"><span style="color: #f00;">*</span>手机号</span>
						<el-input v-model="addHospitaler_phone" placeholder="手机号"></el-input>
					</div>
					<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addHospitalerPhone_tip"><i class="b_icon"></i>手机号格式错误</template></div>
					<div class="base_form_row">
						<span class="b_label"><span style="color: #f00;">*</span>擅长</span>
						<div class="b_checkbox_group">
							<el-checkbox-group v-model="addHospitaler_special">
								<el-checkbox v-for="v in allDisease" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
							</el-checkbox-group>
						</div>
					</div>
					<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addHospitalerSpecial_tip"><i class="b_icon"></i>至少勾选一项</template></div>
				</div>
			</div>
		</Popup>
		<!-- 新增医院弹出框 end -->
		
		<!-- 查看医院弹出框 -->
		<Popup 
			v-model="viewHospital_popup_display"
			title="详情"
			:confirmBtnDisplay="false"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label">编码</span>
					<el-input :value="viewHospital_code" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">名称</span>
					<el-input :value="viewHospital_name" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">所属区域</span>
					<div class="b_select">
						<el-select :value="viewHospital_addr.provinceName" disabled></el-select>
					</div>
					<div class="b_select">
						<el-select :value="viewHospital_addr.cityName" disabled></el-select>
					</div>
					<div class="b_select">
						<el-select :value="viewHospital_addr.areaName" disabled></el-select>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">创建人</span>
					<el-input :value="viewHospital_creater" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">创建时间</span>
					<el-input :value="viewHospital_creatDate" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">修改人</span>
					<el-input :value="viewHospital_updater" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">修改时间</span>
					<el-input :value="viewHospital_updateDate" disabled></el-input>
				</div>
			</div>
		</Popup>
		<!-- 查看医院弹出框 end -->
		
		<!-- 修改医院弹出框 -->
		<Popup 
			v-model="updateHospital_popup_display"
			title="修改医院"
			confirmBtnText="更新"
			@confirmClick="handleUpdateHospitalPopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>编码</span>
					<el-input :value="updateHospital_code" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>名称</span>
					<el-input v-model="updateHospital_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateHospitalName_tip"><i class="b_icon"></i>请输入医院名称</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>所属区域</span>
					<VDistpicker :province="updateHospital_addr.provinceName" :city="updateHospital_addr.cityName" :area="updateHospital_addr.areaName" @province="handleUpdateHospitalAddrProvinceSelect" @city="handleUpdateHospitalAddrCitySelect" @area="handleUpdateHospitalAddrAreaSelect"></VDistpicker>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateHospitalAddr_tip"><i class="b_icon"></i>请选择区域</template></div>
				<div class="base_form_row">
					<span class="b_label">简介</span>
					<el-input
						v-model="updateHospital_desc"
						type="textarea"
						:rows="4"
						placeholder="医院简介"
					>
					</el-input>
				</div>
			</div>
		</Popup>
		<!-- 修改医院弹出框 end -->
		
		<!-- 删除医院弹出框 -->
		<Popup
			v-model="deleteHospital_popup_display"
			title="提示"
			@confirmClick="handleDeleteHospitalPopupConfirmClick"
		>
			<div style="padding: 15px;">
				<p style="color: #5f6468;line-height: 24px;">您确认要删除吗？</p>
			</div>
		</Popup>
		<!-- 删除医院弹出框 end -->
		
		<!-- 医院管理员弹出框 -->
		<Manager
			v-model="manageHospital_popup_display"
			:id="manageHospital_id"
		></Manager>
		<!-- 医院管理员弹出框 end -->
		
		<!-- 充值弹出框 -->
		<Recharge
			v-model="rechargeHospital_popup_display"
			:id="rechargeHospital_id"
			:name="rechargeHospital_name"
			:code="rechargeHospital_code"
			:products="authProduct"
			:objectType="1"
			@success="handleRechargeSuccess"
		></Recharge>
		<!-- 充值弹出框 end -->
		
		<!-- 消费统计弹出框 -->
		<ConsumeCount
			v-model="hospitalConsumeCount_popup_display"
			:id="hospitalConsumeCount_id"
		></ConsumeCount>
		<!-- 消费统计弹出框 end -->
		
		<!-- 充值记录弹出框 -->
		<RechargeRecord
			v-model="hospitalRechargeRecord_popup_display"
			:id="hospitalRechargeRecord_id"
			:code="hospitalRechargeRecord_code"
			type="1"
		></RechargeRecord>
		<!-- 充值记录弹出框 end -->
		
		<!-- 消费记录弹出框 -->
		<ConsumeRecord
			v-model="hospitalConsumeRecord_popup_display"
			:id="hospitalConsumeRecord_id"
			:code="hospitalConsumeRecord_code"
			type="1"
		></ConsumeRecord>
		<!-- 消费记录弹出框 end -->
	</div>
</template>

<script>
	import AreaChoise from "../components/area_choise.vue"
	import Api from "../../../../api/index.js"
	import BaseMethods from "../../../../assets/js/base.js"
	import { mapState } from "vuex"
	import Manager from "./components/manager.vue"
	import Recharge from "./components/recharge.vue"
	import ConsumeCount from "./components/consume_count.vue"
	import RechargeRecord from "./components/recharge_record.vue"
	import ConsumeRecord from "./components/consume_record.vue"
	
	export default {
		data () {
			return {
				loading: false,
				tableData: [],
				
				currentPage: 1,
				total: 0,

				hospital_addr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				hospital_name: '',
				hospital_creater: '',
				hospital_startTime: '',
				hospital_endTime: '',
				
				add_loading: false,
				addHospital_popup_display: false,
				addHospital_name: '',
				addHospital_level: "1",
				addHospitalAddr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				addHospital_desc: '',
				addHospitalName_tip: false,
				addHospitalAddr_tip: false,
				
				addHospitaler_name: '',
				addHospitaler_phone: '',
				addHospitaler_special: [],
				addHospitalerName_tip: false,
				addHospitalerPhone_tip: false,
				addHospitalerSpecial_tip: false,
				
				viewHospital_popup_display: false,
				viewHospital_code: '',
				viewHospital_name: '',
				viewHospital_addr: {
					provinceName: '',
					cityName: '',
					areaName: ''
				},
				viewHospital_creater: '',
				viewHospital_creatDate: '',
				viewHospital_updater: '',
				viewHospital_updateDate: '',
				
				updateHospital_popup_display: false,
				updateHospital_id: '',
				updateHospital_code: '',
				updateHospital_name: '',
				updateHospital_level: '',
				updateHospital_addr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				updateHospital_desc: '',
				updateHospitalName_tip: false,
				updateHospitalAddr_tip: false,
				
				deleteHospital_popup_display: false,
				deleteHospital_ids: '',
				
				manageHospital_popup_display: false,
				manageHospital_id: '',
				
				rechargeHospital_popup_display: false,
				rechargeHospital_id: '',
				rechargeHospital_name: '',
				rechargeHospital_code: '',
				
				hospitalConsumeCount_popup_display: false,
				hospitalConsumeCount_id: '',
				
				hospitalRechargeRecord_popup_display: false,
				hospitalRechargeRecord_id: '',
				hospitalRechargeRecord_code: '',
				
				hospitalConsumeRecord_popup_display: false,
				hospitalConsumeRecord_id: '',
				hospitalConsumeRecord_code: ''
			}
		},
		computed: {
			...mapState(['authInfo', 'authProduct', 'allDisease'])
		},
		mounted () {
			this.getOrganizationList();
		},
		methods: {
			/************************ @Ajax *******************************/
			// 请求数据
			getOrganizationList () {
				const that = this;
				that.loading = true;
				var _requestData = {
					endTime: that.hospital_endTime,
					founderName: that.hospital_creater,
					hosptialName: that.hospital_name,
					limit: 10,
					pageNum: that.currentPage,
					startTime: that.hospital_startTime,
					uareaName: that.hospital_addr.areaName,
					ucategoryLogin: that.authInfo.ucategory,
					ucityName: that.hospital_addr.cityName,
					ufinderCategory: 2,
					uid: null,
					uprovinceName: that.hospital_addr.provinceName,
					warning: null,
					userId: that.authInfo.uid,
					uenterpriseId: that.authInfo.uenterpriseId,
					functionType: 1
				};
				Api.findOrganization(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.total;
						that.tableData = [];
						for (var i = 0;i < res.data.data.list.length;i++) {
							that.tableData.push({
								id: res.data.data.list[i].uenterpriseId,
								name: res.data.data.list[i].uenterpriseName || '',
								code: res.data.data.list[i].ucode || '',
								creater: res.data.data.list[i].founderName || '',
								creatDate: res.data.data.list[i].createTime ? res.data.data.list[i].createTime.split("T")[0] : '',
								provinceName: res.data.data.list[i].uprovinceName || '',
								provinceCode: res.data.data.list[i].uprovinceCode || '',
								cityName: res.data.data.list[i].ucityName || '',
								cityCode: res.data.data.list[i].ucityCode || '',
								areaName: res.data.data.list[i].uareaName || '',
								areaCode: res.data.data.list[i].uareaCode || '',
								updater: res.data.data.list[i].updaterName || '',
								updateDate: res.data.data.list[i].updateTime ? res.data.data.list[i].updateTime.split("T")[0] : '',
								desc: res.data.data.list[i].usynopsis || ''
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 删除组织数据
			deleteOrganization (ids) {
				const that = this;
				that.loading = true;
				var _requestData = {
					uId: ids
				};
				Api.deleteOrganization(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.currentPage = 1;
						that.getOrganizationList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 新增医院
			addHospital () {
				const that = this;
				that.add_loading = true;
				var requestData = {
					openNewMechanismVo: {
						uaddress: null,
						uareaCode: that.addHospitalAddr.areaCode,
						uareaName: that.addHospitalAddr.areaName,
						ucategory: 2,
						ucityCode: that.addHospitalAddr.cityCode,
						ucityName: that.addHospitalAddr.cityName,
						ucode: null,
						ucreate: null,
						ucreateTs: null,
						udeviceNos: null,
						udoubleTaskPeriod: 0,
						udr: 0,
						uid: null,
						uisBackstage: 0,
						uisCard: 0,
						uisSuperiorsPay: 0,
						umemo: null,
						uname: that.addHospital_name,
						unationalityCode: null,
						unationalityName: null,
						uoperateTime: null,
						uphone: null,
						uphoto: null,
						upollCode: null,
						uprovinceCode: that.addHospitalAddr.provinceCode,
						uprovinceName: that.addHospitalAddr.provinceName,
						uqualifications: null,
						usynopsis: that.addHospital_desc,
						utel: null,
						utypeId: that.addHospital_level,
						uupdate: null,
						uupdateTs: null,
						uvsersionStatus: 0
					},
					openUmBUserVo: {
						isExamine: null,
						password: null,
						uareaCode: that.addHospitalAddr.areaCode,
						uareaName: that.addHospitalAddr.areaName,
						ucategory: 3,
						ucategorySpecific: null,
						ucityCode: that.addHospitalAddr.cityCode,
						ucityName: that.addHospitalAddr.cityName,
						ucode: that.addHospitaler_phone,
						ucreate: null,
						ucreateTs: null,
						uenterpriseId: null,
						uexpert: that.addHospitaler_special.join(","),
						uid: null,
						ulevel: null,
						uname: that.addHospitaler_name,
						unationalityCode: null,
						unationalityName: null,
						unionid: null,
						uphone: that.addHospitaler_phone,
						"uprovinceCode": that.addHospitalAddr.provinceCode,
						"uprovinceName": that.addHospitalAddr.provinceName,
						usex: null
					},
					"type": "b",
					ucode: that.authInfo.ucode,
					uid: null
				};
				Api.addOrganization(requestData).then((res) => {
					that.add_loading = false;
					if (res.data.success) {
						that.addHospital_popup_display = false;
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.getOrganizationList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.add_loading = false;
					that.$message.error(e.message);
				});
			},
			/************************ @Events *******************************/
			// 选择城市
			handleAreaChoiseSelect (data) {
				if (data.sign == "P") {	// 省份
					this.hospital_addr.provinceName = data.label;
					this.hospital_addr.provinceCode = data.key.slice(0, 3);
					this.hospital_addr.cityName = '';
					this.hospital_addr.cityCode = '';
					this.hospital_addr.areaName = '';
					this.hospital_addr.areaCode = '';
					this.currentPage = 1;
					this.getOrganizationList();
				} else if (data.sign == "C") {	// 城市
					this.hospital_addr.provinceName = data.parentLabel;
					this.hospital_addr.provinceCode = data.parentKey.slice(0, 3);
					this.hospital_addr.cityName = data.label;
					this.hospital_addr.cityCode = data.key + '000000';
					this.hospital_addr.areaName = '';
					this.hospital_addr.areaCode = '';
					this.currentPage = 1;
					this.getOrganizationList();
				} else if (data.sign == "A") {	// 区域
					this.hospital_addr.provinceName = data.grandLabel;
					this.hospital_addr.provinceCode = data.grandKey.slice(0, 3);
					this.hospital_addr.cityName = data.parentLabel;
					this.hospital_addr.cityCode = data.parentKey + '000000';
					this.hospital_addr.areaName = data.label;
					this.hospital_addr.areaCode = data.key + '000000';
					this.currentPage = 1;
					this.getOrganizationList();
				} else {
					this.hospital_addr.provinceName = '';
					this.hospital_addr.provinceCode = '';
					this.hospital_addr.cityName = '';
					this.hospital_addr.cityCode = '';
					this.hospital_addr.areaName = '';
					this.hospital_addr.areaCode = '';
					this.currentPage = 1;
					this.getOrganizationList();
				}
			},
			// 切换查询时间
			handleSearchStartTimeClick () {
				this.compareSearchTime();
			},
			// 切换查询时间
			handleSearchEndTimeClick () {
				this.compareSearchTime();
			},
			// 点击查询
			handleSearchClick () {
				this.currentPage = 1;
				this.getOrganizationList();
			},
			// 点击页码
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getOrganizationList();
				}
			},
			// 导出Excel数据
			exportExcel () {
				const that = this;
				that.loading = true;
				var _requestData = {
					endTime: that.hospital_endTime,
					founderName: that.hospital_creater,
					hosptialName: that.hospital_name,
					limit: 10000,
					pageNum: 1,
					startTime: that.hospital_startTime,
					uareaName: that.hospital_addr.areaName,
					ucategoryLogin: that.authInfo.ucategory,
					ucityName: that.hospital_addr.cityName,
					ufinderCategory: 2,
					uid: null,
					uprovinceName: that.hospital_addr.provinceName,
					warning: null,
					userId: that.authInfo.uid,
					uenterpriseId: that.authInfo.uenterpriseId,
					functionType: 2
				};
				Api.findOrganization(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						var str = '序号,企业名称,编码,创建人,创建时间,\n';
						for (var i = 0;i < res.data.data.list.length;i++) {
							str += `${ i+1 },${ res.data.data.list[i].uenterpriseName || '' },${ res.data.data.list[i].ucode || '' }\t,${ res.data.data.list[i].founderName || '' },${ res.data.data.list[i].createTime ? res.data.data.list[i].createTime.split("T")[0] : '' }\t,\n`;
							// data.push({
							// 	name: res.data.data.list[i].uenterpriseName || '',
							// 	code: res.data.data.list[i].ucode || '',
							// 	creater: res.data.data.list[i].founderName || '',
							// 	creatDate: res.data.data.list[i].createTime ? res.data.data.list[i].createTime.split("T")[0] : ''
							// });
						}
						BaseMethods.outputExcel(str, '医院管理');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击新增医院
			handleAddHospitalClick () {
				let default_specialIds = [];
				this.allDisease.forEach(v => {
					v.id == 1 && default_specialIds.push(v.id);
					v.id == 2 && default_specialIds.push(v.id);
					v.id == 3 && default_specialIds.push(v.id);
					v.id == 4 && default_specialIds.push(v.id);
					v.id == 5 && default_specialIds.push(v.id);
					v.id == 6 && default_specialIds.push(v.id);
					v.id == 7 && default_specialIds.push(v.id);
					v.id == 9 && default_specialIds.push(v.id);
				});
				
				this.addHospital_name = '';
				this.addHospital_level = "1";
				this.addHospitalAddr = {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				};
				this.addHospital_desc = '';
				this.addHospitalName_tip = false;
				this.addHospitalAddr_tip = false;

				this.addHospitaler_name = '';
				this.addHospitaler_phone = '';
				this.addHospitaler_special = default_specialIds;
				this.addHospitalerName_tip = false;
				this.addHospitalerPhone_tip = false;
				this.addHospitalerSpecial_tip = false;

				this.addHospital_popup_display = true;
			},
			// 新增医院地址省份选择
			handleAddHospitalAddrProvinceSelect (data) {
				this.addHospitalAddr.provinceName = data.code ? data.value : '';
				this.addHospitalAddr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 新增医院地址城市选择
			handleAddHospitalAddrCitySelect (data) {
				this.addHospitalAddr.cityName = data.code ? data.value : '';
				this.addHospitalAddr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 新增医院地址区域选择
			handleAddHospitalAddrAreaSelect (data) {
				this.addHospitalAddr.areaName = data.code ? data.value : '';
				this.addHospitalAddr.areaCode = data.code ? `${ data.code }000000` : '';
			},
			// 点击新增医院弹框新增按钮
			handleAddHospitalPopupConfirmClick () {
				const that = this;
				if (!that.addHospital_name.trim()) {
					that.addHospitalName_tip = true;
					return false;
				} else {
					that.addHospitalName_tip = false;
				}
				if (!that.addHospitalAddr.areaCode) {
					that.addHospitalAddr_tip = true;
					return false;
				} else {
					that.addHospitalAddr_tip = false;
				}
				if (!that.addHospitaler_name.trim()) {	// 校验姓名
					that.addHospitalerName_tip = true;
					return false;
				} else {
					that.addHospitalerName_tip = false;
				}
				if (!that.phoneReg.test(that.addHospitaler_phone)) {	// 校验手机号
					that.addHospitalerPhone_tip = true;
					return false;
				} else {
					that.addHospitalerPhone_tip = false;
				}
				if (!that.addHospitaler_special.length) {	// 校验擅长
					that.addHospitalerSpecial_tip = true;
					return false;
				} else {
					that.addHospitalerSpecial_tip = false;
				}
				that.addHospital();
			},
			// 点击查看
			handleViewHospitalClick (data) {
				this.viewHospital_popup_display = true;
				this.viewHospital_code = data.code;
				this.viewHospital_name = data.name;
				this.viewHospital_addr.provinceName = data.provinceName;
				this.viewHospital_addr.cityName = data.cityName;
				this.viewHospital_addr.areaName = data.areaName;
				this.viewHospital_creater = data.creater;
				this.viewHospital_creatDate = data.creatDate;
				this.viewHospital_updater = data.updater;
				this.viewHospital_updateDate = data.updateDate;
			},
			// 点击修改
			handleUpdateHospitalClick (data) {
				this.updateHospital_id = data.id;
				this.updateHospital_code = data.code;
				this.updateHospital_name = data.name;
				this.updateHospital_level = data.utypeId;
				this.updateHospital_addr.provinceName = data.provinceName;
				this.updateHospital_addr.provinceCode = data.provinceCode;
				this.updateHospital_addr.cityName = data.cityName;
				this.updateHospital_addr.cityCode = data.cityCode;
				this.updateHospital_addr.areaName = data.areaName;
				this.updateHospital_addr.areaCode = data.areaCode;
				this.updateHospital_desc = data.desc;
				this.updateHospitalName_tip = false;
				this.updateHospitalAddr_tip = false;
				this.updateHospital_popup_display = true;
			},
			// 修改医院地址省份选择
			handleUpdateHospitalAddrProvinceSelect (data) {
				this.updateHospital_addr.provinceName = data.code ? data.value : '';
				this.updateHospital_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 修改医院地址城市选择
			handleUpdateHospitalAddrCitySelect (data) {
				this.updateHospital_addr.cityName = data.code ? data.value : '';
				this.updateHospital_addr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 修改医院地址区域选择
			handleUpdateHospitalAddrAreaSelect (data) {
				this.updateHospital_addr.areaName = data.code ? data.value : '';
				this.updateHospital_addr.areaCode = data.code ? `${ data.code }000000` : '';
			},
			// 点击修改弹框更新
			handleUpdateHospitalPopupConfirmClick () {
				const that = this;
				if (!that.updateHospital_name.trim()) {
					that.updateHospitalName_tip = true;
					return false;
				} else {
					that.updateHospitalName_tip = false;
				}
				if (!that.updateHospital_addr.areaCode) {
					that.updateHospitalAddr_tip = true;
					return false;
				} else {
					that.updateHospitalAddr_tip = false;
				}
				that.loading = true;
				var _requestData = {
					openNewMechanismVo: {
						uaddress: null,
						uareaCode: that.updateHospital_addr.areaCode,
						uareaName: that.updateHospital_addr.areaName,
						ucategory: 2,
						ucityCode: that.updateHospital_addr.cityCode,
						ucityName: that.updateHospital_addr.cityName,
						ucode: null,
						ucreate: null,
						ucreateTs: null,
						udeviceNos: null,
						udoubleTaskPeriod: 0,
						udr: 0,
						uid: that.updateHospital_id,
						uisBackstage: 0,
						uisCard: 0,
						uisSuperiorsPay: 0,
						umemo: null,
						uname: that.updateHospital_name,
						unationalityCode: null,
						unationalityName: null,
						uoperateTime: null,
						uphone: null,
						uphoto: null,
						upollCode: null,
						uprovinceCode: that.updateHospital_addr.provinceCode,
						uprovinceName: that.updateHospital_addr.provinceName,
						uqualifications: null,
						usynopsis: that.updateHospital_desc,
						utel: null,
						utypeId: that.updateHospital_level,
						uupdate: null,
						uupdateTs: null,
						uvsersionStatus: 0
					},
					ucode: that.authInfo.ucode,
					uid: null
				};
				Api.updateOrganization(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.updateHospital_popup_display = false;
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.getOrganizationList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击批量删除
			handleBatchDeleteClick () {
				if (this.deleteHospital_ids.length) {
					this.deleteHospital_popup_display = true;
				} else {
					this.$message({
						message: '请勾选要删除的医院',
						type: 'warning'
					});
				}
			},
			// 表格选择
			handleTableSelectionChange (val) {
				this.deleteHospital_ids = [];
				for (var i = 0;i < val.length;i++) {
					this.deleteHospital_ids.push(val[i].id);
				}
			},
			// 点击删除弹框确定
			handleDeleteHospitalPopupConfirmClick () {
				this.deleteHospital_popup_display = false;
				this.deleteOrganization(JSON.stringify(this.deleteHospital_ids));
			},
			// 点击医院管理员
			handleManageHospitalClick (data) {
				this.manageHospital_id = data.id;
				this.manageHospital_popup_display = true;
			},
			// 点击充值
			handleRechargeHospitalClick (data) {
				this.rechargeHospital_id = data.id;
				this.rechargeHospital_name = data.name;
				this.rechargeHospital_code = data.code;
				this.rechargeHospital_popup_display = true;
			},
			// 充值成功
			handleRechargeSuccess (msg) {
				this.$message({
					message: msg,
					type: 'success'
				});
				this.rechargeHospital_popup_display = false;
			},
			// 点击消费统计
			handleHospitalConsumeCountClick (data) {
				this.hospitalConsumeCount_id = data.id;
				this.hospitalConsumeCount_popup_display = true;
			},
			// 点击充值记录
			handleHospitalRechargeRecordClick (data) {
				this.hospitalRechargeRecord_id = data.id;
				this.hospitalRechargeRecord_code = data.code;
				this.hospitalRechargeRecord_popup_display = true;
			},
			// 点击消费记录
			handleHospitalConsumeRecordClick (data) {
				this.hospitalConsumeRecord_id = data.id;
				this.hospitalConsumeRecord_code = data.code;
				this.hospitalConsumeRecord_popup_display = true;
			},
			/************************ @Function *******************************/
			// 比较开始时间和结束时间
			compareSearchTime () {
				if (this.hospital_startTime && this.hospital_endTime) {
					var startTime = new Date(this.hospital_startTime).getTime(),
						endTime = new Date(this.hospital_endTime).getTime();
					if (endTime < startTime) {
						this.hospital_endTime = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			}
		},
		components: {
			AreaChoise,
			Manager,
			Recharge,
			ConsumeCount,
			RechargeRecord,
			ConsumeRecord
		}
	}
</script>

<style scoped>
</style>
